<template>
  <LMap
    :zoom="zoom"
    :center="center"
    :options="mapOptions"
    @update:center="centerUpdate"
    @update:zoom="zoomUpdate"
    class="bsmap"
  >
    <LTileLayer :url="url" :attribution="attribution" />
    <LControlZoom position="bottomleft"></LControlZoom>
    <template v-for="(station, i) in stations">
      <LMarker
        :lat-lng="getLatLong(station.lat, station.lon)"
        :key="`station-${i}`"
      >
        <LPopup>
          <BSStation :station="station" />
        </LPopup>
      </LMarker>
    </template>
  </LMap>
</template>

<script>
import { latLng } from 'leaflet'
import { LMap, LTileLayer, LMarker, LPopup, LControlZoom } from 'vue2-leaflet'
import BSStation from './BSStation.vue'

export default {
  name: 'BSMap',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LControlZoom,
    BSStation,
  },
  props: {
    stations: Array,
    ready: Boolean,
  },
  data() {
    return {
      zoom: 12.5,
      center: latLng(59.929005, 10.7496755),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a>',
      currentZoom: 11.5,
      currentCenter: latLng(59.929005, 10.7496755),
      mapOptions: {
        zoomSnap: 0.5,
        zoomControl: false,
      },
    }
  },
  methods: {
    zoomUpdate(zoom) {
      this.currentZoom = zoom
    },
    centerUpdate(center) {
      this.currentCenter = center
    },
    getLatLong(lat, long) {
      return latLng(lat, long)
    },
  },
}
</script>
